import { useState } from 'react';

import CopyButton from '../widgets/CopyButton';
import * as utils from '../../services/utils';

function AuthCodeCmd(props) {
  const authorizeParam = utils.AUTH_INFO;
  const authCodeResponseType = utils.AUTH_CODE_RESPONSE_TYPE;

  const [authorizeData, setAuthorizeData] = useState({});
  const [authURL, setAuthURL] = useState('');

  const cmdData = props.cmdData;
  cmdData.displayCmdData = (data) => {
    setAuthorizeData(data);
    setAuthURL(cmdData.buildAuthCmd());
  };

  // Authorization Code
  const codeData = 
  <div>
    <div id="generatedCmd" className="main-form-output white-text">
      <span className="code-line light-blue-text">{authorizeData.authorizeUri}</span>

      <span className="code-line code-line-param aqua-text"> ?{authorizeParam.clientId}=
        <span className="light-blue-text">{authorizeData.clientId}</span></span>
      <span className="code-line code-line-param aqua-text"> &amp;{authorizeParam.redirectUri}=
        <span className="light-blue-text">{authorizeData.redirectUri}</span></span>
      {authorizeData.scopes && <span className="code-line code-line-param aqua-text"> &amp;{authorizeParam.scopes}=
        <span className="light-blue-text">{authorizeData.scopes}</span></span>}       
      <span className="code-line code-line-param aqua-text"> &amp;{authorizeParam.responseType}=
        <span className="light-blue-text">{authCodeResponseType}</span></span>

      {authorizeData.codeChallenge && <span className="code-line code-line-param aqua-text"> &amp;{authorizeParam.codeChallenge}=
        <span className="light-blue-text">{authorizeData.codeChallenge}</span></span>}
      {authorizeData.codeChallengeMethod && <span className="code-line code-line-param aqua-text"> &amp;{authorizeParam.codeChallengeMethod}=
        <span className="light-blue-text">{authorizeData.codeChallengeMethod}</span></span>}

      {authorizeData.state && <span className="code-line code-line-param aqua-text"> &amp;{authorizeParam.state}=
        <span className="light-blue-text">{authorizeData.state}</span></span>}
      {authorizeData.nonce && <span className="code-line code-line-param aqua-text spc-pb-6"> &amp;{authorizeParam.nonce}=
        <span className="light-blue-text">{authorizeData.nonce}</span></span>}
    </div>

    <CopyButton data={authURL}></CopyButton>

  </div>

  if (authorizeData.authorizeUri) {  
    return (    
      <div className="card card-body code-block">
        {codeData}    
       </div>
    );
  }

  return <div></div>
}

export default AuthCodeCmd;
